// extracted by mini-css-extract-plugin
export var loadingSpinner = "_5c-1";
export var standaloneTable = "_5c-0";